import { render, staticRenderFns } from "./DatasetCard.vue?vue&type=template&id=781727d0&scoped=true&"
import script from "./DatasetCard.vue?vue&type=script&lang=js&"
export * from "./DatasetCard.vue?vue&type=script&lang=js&"
import style0 from "./DatasetCard.vue?vue&type=style&index=0&id=781727d0&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "781727d0",
  null
  
)

component.options.__file = "DatasetCard.vue"
export default component.exports